import { useNavigate } from "react-router-dom";
import Brands from "../components/Brands";
import burger from "../assets/images/brands/burger.png";
import pizza from "../assets/images/brands/pizza.png";
import noodles from "../assets/images/brands/noodels.png";
import burgerIcon from "../assets/images/brands/b-burger.png";
import pizzaIcon from "../assets/images/brands/b-pizza.png";
import noodlesIcon from "../assets/images/brands/b-noodles.png";

// Aligned with mobile App/Constants BRANDS (static showcase)
const BRANDS = [
  {
    id: "1",
    title: "Burger",
    image: burger,
    icon: burgerIcon,
    subTitle: "By Burger King",
    accentColor: "#7F29FF",
    search: "burger",
  },
  {
    id: "2",
    title: "Pizza",
    image: pizza,
    icon: pizzaIcon,
    subTitle: "By Pizza Hut",
    accentColor: "#FFC529",
    search: "pizza",
  },
  {
    id: "3",
    title: "Noodles",
    image: noodles,
    icon: noodlesIcon,
    subTitle: "By Noodles Co.",
    accentColor: "#4AE164",
    search: "noodles",
  },
  {
    id: "4",
    title: "Pizza",
    image: pizza,
    icon: pizzaIcon,
    subTitle: "By Pizza Hut",
    accentColor: "#FF6B6B",
    search: "pizza",
  },
  {
    id: "5",
    title: "Noodles",
    image: noodles,
    icon: noodlesIcon,
    subTitle: "By Noodles Co.",
    accentColor: "#4ECDC4",
    search: "noodles",
  },
  {
    id: "6",
    title: "Burger",
    image: burger,
    icon: burgerIcon,
    subTitle: "By Burger King",
    accentColor: "#FF8C42",
    search: "burger",
  },
];

const PopularBrands = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex justify-between items-center">
        <p className="text-gray-900 dark:text-white text-left font-urbanist text-2xl font-semibold leading-[140%] my-4">
          Popular brands
        </p>
      </div>

      <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
        {BRANDS.map((brand, index) => (
          <Brands
            key={brand.id}
            index={index}
            name={brand.title}
            image={brand.image}
            icon={brand.icon}
            by={brand.subTitle}
            accentColor={brand.accentColor}
            onClick={() =>
              navigate(`/result?keyword=${encodeURIComponent(brand.search)}`)
            }
          />
        ))}
      </div>
    </div>
  );
};

export default PopularBrands;
